angular.module("ainapp")
    .controller("pendingPurchaseDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Pending Purchase Dashboard";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.VoucherArray = [];

                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    MainService.MaterialRequestInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Material Request",
                            Order: 1,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.MaterialRequest != "" & $scope.CompanyProfile.MaterialRequest != null) {
                            temp.VoucherName = $scope.CompanyProfile.MaterialRequest;
                        }

                        $scope.VoucherArray.push(temp);

                    })


                    MainService.PurchaseRequestInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Purchase Request",
                            Order: 2,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.PurchaseRequest != "" & $scope.CompanyProfile.PurchaseRequest != null) {
                            temp.VoucherName = $scope.CompanyProfile.PurchaseRequest;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.PurchaseEnquiryInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Purchase Enquiry",
                            Order: 3,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.PurchaseEnquiry != "" & $scope.CompanyProfile.PurchaseEnquiry != null) {
                            temp.VoucherName = $scope.CompanyProfile.PurchaseEnquiry;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.PurchaseQuotationInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Purchase Quotation",
                            Order: 4,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.PurchaseQuotation != "" & $scope.CompanyProfile.PurchaseQuotation != null) {
                            temp.VoucherName = $scope.CompanyProfile.PurchaseQuotation;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.PurchaseOrderInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Purchase Order",
                            Order: 4,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.PurchaseOrder != "" & $scope.CompanyProfile.PurchaseOrder != null) {
                            temp.VoucherName = $scope.CompanyProfile.PurchaseOrder;
                        }

                        $scope.VoucherArray.push(temp);

                    })


                    MainService.GoodsReceivedInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Goods Received",
                            Order: 6,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.GoodsReceived != "" & $scope.CompanyProfile.GoodsReceived != null) {
                            temp.VoucherName = $scope.CompanyProfile.GoodsReceived;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.PurchaseInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Purchase Invoice",
                            Order: 7,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.PurchaseInvoice != "" & $scope.CompanyProfile.PurchaseInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.PurchaseInvoice;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.DirPurchaseInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Direct Purchase Invoice",
                            Order: 8,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.DirPurchaseInvoice != "" & $scope.CompanyProfile.DirPurchaseInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.DirPurchaseInvoice;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.IndPurchaseInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Individual Purchase Invoice",
                            Order: 9,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.IndPurchaseInvoice != "" & $scope.CompanyProfile.IndPurchaseInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.IndPurchaseInvoice;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.ImpPurchaseInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Import Purchase Invoice",
                            Order: 10,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.ImpPurchaseInvoice != "" & $scope.CompanyProfile.ImpPurchaseInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.ImpPurchaseInvoice;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.ExpPurchaseInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Export Purchase Invoice",
                            Order: 11,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.ExpPurchaseInvoice != "" & $scope.CompanyProfile.ExpPurchaseInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.ExpPurchaseInvoice;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.PurchaseReturnInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Purchase Return",
                            Order: 12,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.PurchaseReturn != "" & $scope.CompanyProfile.PurchaseReturn != null) {
                            temp.VoucherName = $scope.CompanyProfile.PurchaseReturn;
                        }

                        $scope.VoucherArray.push(temp);

                    })





                })





            }
            $scope.Init();

                        }])
